import { v4 as uuidv4 } from "uuid";
export class PAStepModel {
    constructor() {
        this.id = uuidv4();
        this.name = "";
        this.targetAudienceId = null;
        this.roleId = null;
        this.userId = null;
        this.defaultDuration = 2;
        this.isInternalStakeholder = false;
        this.clientAssignmentApplicable = false;
        this.targetAudienceName = "";
        this.audienceDetailName = "";
        this.roleMembersParticipation = false;
    }
}
export default class PAStep extends PAStepModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
